import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FinancialOverview } from '@app/shared/models/financial-overview.model';
import { SelectedRange } from '@app/shared/models/volume-dashboard.model';

@Component({
  selector: 'app-financial-overview-report',
  templateUrl: './financial-overview-report.component.html',
  styleUrl: './financial-overview-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FinancialOverviewReportComponent {
  @Input() report: FinancialOverview | null = null;
  @Input() selectedRange: SelectedRange | null = null;
  @Input() isLoading = false;

  get hasData(): boolean {
    return (this.report?.revenue.totals.total.value ?? 0) > 0 ||
      (this.report?.payouts.totals.postTax.value ?? 0) > 0;
  }
}
